import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../_metronic/_partials/controls/Card";
import { baseURL } from "../service/API.js";
import { useSubheader } from "../../_metronic/layout";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import xlsxFile from "read-excel-file";
import Button from "@material-ui/core/Button";
import { useLocation } from "react-router-dom";
import { Modal, Container, Row, Col, Form, Nav } from "react-bootstrap";

import { Link } from "react-router-dom";
import * as XLSX from "sheetjs-style";
import {
  style2,
  listHeader2,
  wscols,
  listHeader,
  merge,
  style,
} from "../document/example_template.xlsx";
import { useHistory } from "react-router-dom";
import whitelist_template from "../document/point_template.xlsx";
import { useIntl } from "react-intl";

export const AddPoint = () => {
  const { user, authToken } = useSelector((state) => state.auth);
  const suhbeader = useSubheader();
  const intl = useIntl();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Menu" }));
  const [nameEN, setNameEN] = useState("");
  const [currentID, setCurrentID] = useState("");
  const history = useHistory();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [isFileName, setFileName] = useState();
  const [status, setStatus] = useState(true);
  const [state, setState] = useState({
    imageId: null,
    imageName: "",
    imageURL: "",
  });
  const [isUpload, setIsUpload] = useState(false);
  const [progress, setProgress] = useState(0);
  const search = useLocation().search;

  const AlertError = (message) => {
    Swal.fire("", message, "error");
  };
  useEffect(() => {}, []);

  const handleUploadXLSX = async (file) => {
    var formdata = new FormData();
    formdata.append("xlsx", file, file.name);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    fetch(`${baseURL}/api/v1/point`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
      })
      .catch((error) => console.log("error", error));
  };

  const handleUploadFile = async () => {
    console.log("test", isFilePicked);
    console.log(selectedFile);
    if (!isFilePicked) {
      return AlertError("Error, please select file!!");
    }

    let file = selectedFile;
    let check_error = false;
    setIsUpload(true);
    setProgress(25);
    let data_all = [];
    var formdata = new FormData();
    formdata.append("xlsx", file, file.name);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    if (!check_error) {
      Swal.fire({
        title: "",
        text: "Confirm Add point",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let apiUrls = `${baseURL}/api/v1/point`;
          let token = localStorage.getItem("Token");
          fetch(`${baseURL}/api/v1/point`, requestOptions)
            .then((response) => response.text())
            .then(async (result) => {
              let res = JSON.parse(result);
              setProgress(100);
              await Swal.fire({
                title: "",
                text: "Successfully",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true,
              }).then(async (result2) => {
                window.location.reload();
              });
            })
            .catch((error) => console.log("error", error));
        } else {
          setIsUpload(false);
          setProgress(0);
        }
      });
    }
  };

  const handleChangeItem = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      // e.target.value = '';
      // handleChangeFile(file);
      setSelectedFile(file);
      setIsFilePicked(true);
      setFileName(file.name);
    }
    /*if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = '';
      handleChangeFile(file)
    }*/
  };

  const handleChangeFile = async (file) => {
    let check_error = false;
    setIsUpload(true);
    setProgress(25);
    if (nameEN == "" || nameEN == undefined) {
      setProgress(0);
      setIsUpload(false);

      return AlertError("Error, please insert name!!");
    }
    //e.preventDefault();
    /*let file = e.target.files[0];
    var reader = new FileReader();
    e.target.value = '';
    reader.readAsDataURL(file);*/
    let data_all = [];
    await xlsxFile(file).then(async (rows) => {
      setProgress(100);
      console.log(rows);
      if (rows[0][0] !== "Value") {
        setProgress(0);
        setIsUpload(false);
        check_error = true;
        return AlertError("Error, wrong column name!!");
      }

      await rows.map((data, i) => {
        if (i !== 0) {
          let fuel = {
            value: data[0],
            note: "-",
          };
          data_all.push(fuel);
        }
      });

      console.log(data_all);
    });

    let events = {
      whitelist: JSON.stringify(data_all),
    };
    if (!check_error) {
      Swal.fire({
        title: "",
        text: "Confirm Add Whitelist",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let apiUrls = `${baseURL}/whitelist/add/${currentID}`;
          let token = localStorage.getItem("Token");
          console.log(events);
          const resultAll = axios({
            method: "put",
            url: apiUrls,
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
            data: events,
          })
            .then(async (res) => {
              history.goBack();
            })
            .catch((err) => {
              setProgress(0);
              setIsUpload(false);
              Swal.fire("", "Can not Create Whitelist !! " + err, "error");
            });
        }
      });
    }
  };

  return (
    <Card>
      <CardHeader title="Add point"></CardHeader>
      <CardBody>
        <>
          <form>
            {/*<Nav variant="tabs" defaultActiveKey="link-0">
              <Nav.Item
                onClick={() => {
                  setStatus(true)
                }}
              >
                <Nav.Link eventKey="link-0">upload file</Nav.Link>
              </Nav.Item>
              <Nav.Item
                onClick={() => {
                  setStatus(false)

                }}
              >
                <Nav.Link eventKey="link-1">manual</Nav.Link>
              </Nav.Item>
            </Nav>*/}
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
              }}
            ></div>
            {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                {"Target List Name"}
                <span style={{ color: "red" }}>
                  *
                </span>
              </p>
              <input
                value={nameEN}
                name="item_name"
                maxLength="100"
                style={{
                  height: "38px",
                  width: "530px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                onChange={(item_name) => {
                  setNameEN(item_name.target.value)
                }}
              />
            </div>*/}
            {status && <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                Upload file <span style={{ color: "red" }}>*</span>: <br></br>
              </p>
              <input
                name="ImageURL"
                style={{
                  height: "38px",
                  width: "330px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                disabled
                value={isFileName}
                // value={state.imageURL}
              />

              <span className="btn btn-primary btn-file wbt">
                Select File
                <input
                  type="file"
                  accept=".xlsx, .xls, .csv"
                  onChange={handleChangeItem}
                />
              </span>
              <a
                href={whitelist_template}
                target="_blank"
                download="point_template.xlsx"
              >
                <span className="btn btn-primary btn-file wbt">Example</span>
              </a>
            </div>}

            {!status && <div className="form-inline" style={{ marginBottom: "25px" }}>
              
            </div>}

            {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "-45px", float: "left", width: "20%" }}>
                (){" "}
                <span style={{ color: "red" }}></span> <br></br>
              </p>
            </div>*/}

            {isUpload ? (
              <div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}
                  </div>
                </div>
              </div>
            ) : null}
          </form>

          {/*<Link to="/files/master_fuel_template.xlsx" target="_blank" download>
            <button className="btn btn-primary mt-3">
              Download Excel Template
            </button>
          </Link>*/}
          {/*<button className="btn btn-primary mt-3"
            onClick={() => {
              getPDF()
            }}
          >
            Download Excel Template
          </button>*/}
          {/*<Link onClick={() => { history.goBack() }}>
            <button type="button" className="btn btn-secondary wbt mr-5">
              {"Cancel"}
            </button>
          </Link>*/}
          <button
            type="button"
            className="btn btn-primary wbt mr-5"
            onClick={handleUploadFile}
          >
            {"Save"}
          </button>
        </>
      </CardBody>
    </Card>
  );
};
